<template>
  <transition name="fade">
    <div class="sidebar-actions" v-show="visible">
      <div class="sidebar-btn sidebar-btn--active flex-row" @click="toPc">
        <img class="sidebar-btn__bg" referrerpolicy="no-referrer" src="../assets/img/btn-icon-active.png" />
        <div class="sidebar-btn__inner flex-col justify-between" style="margin-top: 5px;">
          <img
            class="sidebar-btn__icon"
            referrerpolicy="no-referrer"
            src="../assets/img/icon-pc.png"
          /> 
        </div>
        <div class="sidebar-btn__text">电脑端</div>
      </div>
      <div class="sidebar-btn sidebar-btn--active flex-row" @click="scrollToTop">
        <img class="sidebar-btn__bg" referrerpolicy="no-referrer" src="../assets/img/btn-icon-active.png" />
        <div class="sidebar-btn__inner flex-col justify-between">
          <img
            class="sidebar-btn__icon"
            referrerpolicy="no-referrer"
            src="../assets/img/icon-top.png"
          />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'BackTop',
  data() {
    return {
      keyword: '',
      visible: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      this.visible = window.scrollY > 10
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    toPc() {
      window.open('https://shengtaibaohu.com.cn/')
    }
  }
}
</script>

<style lang="scss" scoped>

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.sidebar-actions {
  width: 40px;
  height: 40px;
  position: fixed;
  bottom: 60px;
  right: 10px;

  .sidebar-btn {
    position: relative;
    width: 40px;
    height: 40px;

    &:not(:first-child) {
      margin-top: 10px;
    }

    &--dark {
      background-color: rgba(45, 83, 194, 1);
      border-radius: 7px;
    }

    &--active {
      .sidebar-btn__bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    &__bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    &__inner {
      position: relative;
      z-index: 1;
      width: 15px; 
      height: 40px;
      margin: 10px 0 0 10px;
    } 

    &__icon {
      width: 20px;
      height: 20px;
    } 
    &__text {
      position: absolute;
      color: #fff;
      top: 27px;
      font-size: 9px;
      width: 40px;
      text-align: center;
    } 
  }
}
</style>
